import get from 'lodash.get';

export const selectDeal = store => store.flows.deal;
export const selectAllocate = store => get(selectDeal(store), 'allocate');
export const selectAnnounce = store => get(selectDeal(store), 'announce');
export const selectInvite = store => get(selectDeal(store), 'invite');
export const selectStatus = store => get(selectDeal(store), 'status');



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/selectors.js